// src/hooks/usePresignedDownloadUrl.ts
import { useQuery } from '@tanstack/react-query';
import { downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetOptions } from '@/client/@tanstack/react-query.gen';
import { useHouseContext } from '../context/HouseContext';

/**
 * Hook for fetching presigned download URLs using TanStack Query
 */
const usePresignedDownloadUrl = (documentId: number, enabled: boolean = false) => {
	const { selectedHouse } = useHouseContext();

	return useQuery({
		...downloadDocumentOptimizedHousesHouseIdDocumentsDocumentIdDownloadGetOptions({
			path: {
				house_id: selectedHouse?.id || 0,
				document_id: documentId,
			},
		}),
		enabled: enabled && !!selectedHouse?.id,
		staleTime: 0, // URLs expire quickly, don't cache
		gcTime: 0, // Don't keep in cache
	});
};

export default usePresignedDownloadUrl;
